export enum MatrixDataTestIds {
    AsideCellSecondaryText = 'aside-cell-secondary-text',
    AsideCellGuestsValue = 'guests-value',
}
